
import EditProfileForm from 'components/EditProfileForm';
import EditProfileTitle from 'components/EditProfileTitle';
import EditProfileFormContainer from 'components/EditProfileFormContainer';
import ProfileFormEditContainer from 'components/ProfileFormEditContainer';
import EditProfileIconButton from 'components/EditProfileIconButton';
import ProfileFormNameEditField from 'components/ProfileFormNameEditField';
import rq from 'components/RedQuick';
import EditFormParentControls from 'components/EditFormParentControls';
import { useState, useRef, useEffect } from 'react';
import TitleService from 'title-service';
import { useDispatch, useSelector } from 'react-redux';
import AvatarItem from './AvatarItem';
import { useParams } from 'react-router-dom';
import { getUserClaims } from 'features/application/application-slice';
import { useDebounce } from 'components/utility';
import { date } from 'yup';
import { Profile } from 'models';
export default function EditProfile(props: {
    profile: Profile,
    onChange: (args: {
        name: string,
        profileImage: string,
        isKid: boolean
    }) => void
}) {
    const [isChild, setIsChild] = useState(props?.profile?.isKid || false);
    const [birthDate, setBirthDate] = useState(props?.profile?.dateOfBirth);
    const [profileImage, setProfileImage] = useState(resolveImgSrc('Ajani', 256));
    const [profileImageName, setProfileImageName] = useState('Ajani');
    const [name, setName] = useState(props?.profile?.name || '');
    const [openIconSelection, setOpenIconSeletion] = useState(false);
    const componentRef: React.Ref<HTMLDivElement> = useRef(null);
    const componentRef_size = rq.useContainerSize(componentRef);
    const claims = useSelector(getUserClaims);
    let dispatch = useDispatch();
    const debouncedSearchTerm = useDebounce(JSON.stringify({
        name, dateOfBirth: birthDate, profileImage, profileImageName, isChild
    }), 1000);
    const params = useParams();

    useEffect(() => {
        if (params.id) {
            console.log('update param.id');
            setProfileImage(props?.profile?.profileImage)
            setProfileImageName(props?.profile?.profileImageName)
            setName(props?.profile?.name)
            setIsChild(props?.profile?.isKid)
            setBirthDate(props?.profile?.dateOfBirth)
        }
    }, [params.id, props?.profile?.id]);
    useEffect(() => {
        if (debouncedSearchTerm && props.onChange) {
            let data = JSON.parse(debouncedSearchTerm);
            if (data && data.name && data.profileImage && data.profileImageName) {
                props.onChange(data);
            }
        }
    }, [debouncedSearchTerm])

    let profileImagePrefixes = ['Ajani', 'Ausar', 'Auset', 'Beast', 'BeastWizard',
        'Boy', 'Cece', 'Corina', 'Cyrus', 'DeeJay',
        'DJ', 'Durasi', 'Emily', 'Girl', 'Heather', 'Homie', 'Ida', 'Iris', "Ja'Khari",
        'Jungul', 'Leo', 'Little Agent', 'McKenzie', 'Mia', 'Miko', 'Nehebet', 'Olivia', 'Pepper', 'Play',
        'Pookie', 'Prather', 'Princess', 'Roy', 'Seth', 'Shake', 'Silk', 'T', 'Thor', 'Watch'
    ];
    const rows = 7;
    const perRow = Math.max(10, Math.floor(profileImagePrefixes.length / rows));
    const lists: { color: string, component: any }[][] = [];
    const sections: string[] = [];
    if (openIconSelection) {
        for (let i = 0; i < rows; i++) {
            let inner_list: { color: string, component: any }[] = [];
            for (let j = 0; j < perRow; j++) {
                ///profileImagePrefixes[(i * (perRow) + j) % profileImagePrefixes.length]
                inner_list.push({
                    color: 'transparent',
                    component: <AvatarItem
                        onClick={() => {
                            setProfileImage(resolveImgSrc(profileImagePrefixes[(i * (perRow) + j) % profileImagePrefixes.length], (componentRef_size.width || 1000) / perRow));
                            setProfileImageName(profileImagePrefixes[(i * (perRow) + j) % profileImagePrefixes.length]);
                            setOpenIconSeletion(false);
                        }}
                        imgSrc={resolveImgSrc(profileImagePrefixes[(i * (perRow) + j) % profileImagePrefixes.length], (componentRef_size.width || 1000) / perRow)} />
                })
            }
            lists.push(inner_list);
            sections.push(TitleService('Characters'));
        }
    }
    return (
        <>
            <EditProfileForm>
                <EditProfileTitle></EditProfileTitle>
                <EditProfileFormContainer>
                    <EditProfileIconButton profileImage={profileImage} onClick={() => {
                        setOpenIconSeletion(true);
                    }}></EditProfileIconButton>
                    <ProfileFormEditContainer>
                        <ProfileFormNameEditField name={name} onChange={(val) => {
                            setName(val);
                        }} /> {/*  */}
                        <EditFormParentControls isChild={isChild} birthDate={birthDate} onBirthDateChange={(date) => {
                            setBirthDate(date)
                        }} onChange={(child) => {
                            setIsChild(child);
                        }} />
                    </ProfileFormEditContainer>
                </EditProfileFormContainer>
            </EditProfileForm>
            <rq.RedQuickScrollDialog
                open={openIconSelection}
                close={() => {
                    setOpenIconSeletion(false);
                }} >
                <div className='profile'>
                    <header className="sc-cANqwJ eQeHpR"><h2 className="text-color--primary">{TitleService('Choose Avatar')}</h2></header>
                </div>
                <div style={{ position: 'relative', zIndex: 10, overflow: 'hidden' }}>
                    <div style={{ position: 'relative' }}>
                        <rq.RedQuickLoLoList
                            lists={lists}
                            scaleActiveBy={1.1}
                            spaceHeight={80}
                            sections={sections}
                            itemsPerSlide={Math.min(Math.max(Math.floor(componentRef_size.width / 500 * 5), 1), 6)}
                            itemContainerCls="lolo__panel__container profile" />
                    </div>
                </div>
            </rq.RedQuickScrollDialog>
        </>
    )
}
function resolveImgSrc(arg0: string, width: any) {
    let image = [30, 64, 128, 256, 512, 1024].sort((b, a) => {
        return Math.abs(a - width) - Math.abs(b - width);
    });
    if (arg0 === 'Beast' || arg0 === 'BeastWizard') {
        return `/profile-images/${arg0}.png_${image[0]}.png`;
    }
    return `/profile-images/${arg0}_result.png_${image[0]}.png`;
}
